import React from 'react';
import { Layout, Row, Col, Typography, Space } from 'antd';
import { 
  GithubOutlined, 
  WechatOutlined, 
  MailOutlined, 
  HeartOutlined 
} from '@ant-design/icons';
import './index.css';

const { Footer } = Layout;
const { Text, Link } = Typography;

const FooterItem = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Footer className="blog-footer">
      <div className="footer-content">
        <Row gutter={[32, 32]}>
          <Col xs={24} sm={12} md={6}>
            <div className="footer-section">
              <h3>技术博客</h3>
              <Text type="secondary">
                一个专注于前端技术的个人博客，分享React、JavaScript等开发经验和教程。
              </Text>
            </div>
          </Col>
          
          <Col xs={24} sm={12} md={6}>
            <div className="footer-section">
              <h3>快速链接</h3>
              <ul className="footer-links">
                <li><Link href="/">首页</Link></li>
                <li><Link href="/archive">归档</Link></li>
                <li><Link href="/about">关于</Link></li>
                <li><Link href="/write">写文章</Link></li>
              </ul>
            </div>
          </Col>
          
          <Col xs={24} sm={12} md={6}>
            <div className="footer-section">
              <h3>技术栈</h3>
              <ul className="tech-stack">
                <li>React 19</li>
                <li>Ant Design 6</li>
                <li>React Router 7</li>
                <li>JavaScript ES6+</li>
              </ul>
            </div>
          </Col>
          
          <Col xs={24} sm={12} md={6}>
            <div className="footer-section">
              <h3>联系我</h3>
              <Space direction="vertical">
                <Link href="mailto:contact@example.com">
                  <MailOutlined /> contact@example.com
                </Link>
                <Link href="https://github.com" target="_blank">
                  <GithubOutlined /> GitHub
                </Link>
                <Text><WechatOutlined /> 微信: tech_blog</Text>
              </Space>
            </div>
          </Col>
        </Row>
        
        <div className="footer-bottom">
          <Text type="secondary">
            © {currentYear} 技术博客. Made with <HeartOutlined style={{ color: '#ff4d4f' }} /> by React
          </Text>
        </div>
      </div>
    </Footer>
  );
};

export default FooterItem;